import React from 'react';
import { Link } from 'react-router-dom';

/** Hero público — vive en el layout para no remontarse al abrir login. */
export function LandingHeroContent() {
  return (
    <div className="sala-landing-hero__inner">
      <p className="sala-landing-hero__eyebrow">de Edusico</p>
      <h1 id="sala-landing-brand" className="sala-landing-hero__brand">
        Sala
      </h1>
      <p className="sala-landing-hero__lead">Prepara la clase. Entra a Studio.</p>
      <p className="sala-landing-hero__aside">
        Guías, rúbricas y actividades listas para tu curso — cuando estés listo, la sala responde.
      </p>
      <div className="sala-landing-hero__cta">
        <Link to="/login?returnTo=%2Fstudio" className="sala-landing-cta">
          Abrir Studio
        </Link>
      </div>
    </div>
  );
}
